module.exports = __webpack_public_path__ + "static/media/shape-2.293ae8ff.png";